import AjaxManager from "../../ajaxManager";

export default class CustomerDataValidator {
    constructor() {
        this.ajaxManager = new AjaxManager();
    }

    validateBooking(callback) {
        let url = myApp.config.routing.validateBooking;
        let type = 'POST';
        let data = {
            id_reserva: $('#booking-contact [name=id_reserva]').val(),
            dni: $('#booking-contact [name=dni]').val(),
            pin: $('#booking-contact [name=pin]').val(),
            email: $('#booking-contact [name=email]').val(),
            opcion: $('#booking-contact [name=opcion]').val(),
            id_agrupador: $('#booking-contact [name=id_agrupador]').val()
        };

        this.ajaxManager.ajaxCall(type, url, data, callback);
    }

    getBooking(token, option = 9) {
        let url = myApp.config.routing.getBooking;
        let type = 'POST';
        let data = {
            id_reserva: $('[data-contact=idbooking]').val(),
            token: token
        };
        let callback = function callback(data) {
            $('[data-result=summary]').html(data);
            $('[data-result=summary]').removeClass('hidden');
            myApp.popoverManager.initializePopovers();
        };
        this.ajaxManager.ajaxCall(type, url, data, callback);
    }
}
